/*
 * ==============================================================================
 *
 * Copyright (c) 2023. Koninklijke Philips Electronics N.V.
 *
 * All rights are reserved. Reproduction in whole or in part is prohibited without the prior written consent of the copyright holder.
 *
 * ==============================================================================
 */

import React, { useState, useEffect, useContext } from "react";
import { LocationsContext } from ".";
import fetchHelper from "../../services/fetchHelper";
import produce from "immer";

const FacilityDoc = () => {
  const { location, information, setInformation, patientData, setPatientData, setLocation } =
    useContext(LocationsContext);
  const [data, setData] = useState(location || {});

  useEffect(() => {
    console.log(information.cancel);
    if (information.cancel) {
      setData(location);
    }
  }, [information.cancel]);

  const save = async () => {
    if (information.loading) return false;
    try {
      setInformation({ loading: true });
      const response = await fetchHelper.put("/patientmanagement/rest/patients/" + data.id, data);
      console.log(response);
      setInformation({ loading: false, openForm: false });
      setLocation(response);
    } catch (err) {
      setInformation({ loading: false });
      console.log(err);
    }
  };

  useEffect(() => {
    console.log(information.save);
    if (information.save) {
      save();
    }
  }, [information.save]);

  const onChange = (e) => {
    const element = e.target;
    const key = element.dataset.key;
    let value = element.value;
    if (key === "dob") {
      value = new Date(value).getTime();
    }
    setData((prev) =>
      produce(prev, (draft) => {
        draft[key] = value;
      })
    );
    // setData((prev) => ({ ...prev, [key]: value }));
  };

  return (
    <div className="tabContent ptInformation">
      <div className="content">
        <div className="grpHdr">
          <h3>Notes Section</h3>
        </div>

        <div className="row rowStretch">
          <div className="col col-m-100 col50 force-0m">
            <label>
              <span>Clinic Name</span>
              <input type="text" value="" />
            </label>
          </div>
          <div className="col col-m-100 col50"></div>
        </div>

        <div className="row rowStretch ">
          <div className="col col-m-100 col50 force-0m">
            <label>
              <span>Preferred Method of Conact for Alert Escalation</span>
              <textarea placeholder="" className="fullWidth fixed-size"></textarea>
            </label>
          </div>
          <div className="col col-m-100 col50"></div>
        </div>

        <div className="row rowStretch">
          <div className="col col-m-100 col50 force-0m">
            <label>
              <span>Key Staff Contact</span>
              <input type="text" value="" />
            </label>
          </div>
          <div className="col col-m-100 col50">
            <label>
              <span>Surgery Scheduler Contact</span>
              <input type="text" value="" />
            </label>
          </div>
        </div>

        <div className="grpHdr">
          <h3>Device Rep Contact</h3>
        </div>

        <div className="row rowStretch">
          <div className="col col-m-50 col33">
            <label>
              <span>St Jude</span>
              <input type="text" value="" />
            </label>
          </div>
          <div className="col col-m-50 col33 force-0m">
            <label>
              <span>Biotronik</span>
              <input type="text" value="" />
            </label>
          </div>
          <div className="col col-m-50 col33 boston-scientific-col">
            <label>
              <span>Boston Scientific</span>
              <input type="text" value="" />
            </label>
          </div>
          <div className="col col-m-50 col50 force-0m">
            <label>
              <span>Boston Scientific</span>
              <input type="text" value="" />
            </label>
          </div>
          <div className="col col-m-50 col50">
            <label>
              <span>Medtrionic</span>
              <input type="text" value="" />
            </label>
          </div>
        </div>

        <div className="row rowStretch">
          <div className="col col-m-50 col50">
            <label>
              <span>Additional Notes</span>
              <textarea placeholder="" className="fullWidth fixed-size"></textarea>
            </label>
          </div>
          <div className="col col50"></div>
        </div>

        <div className="grpHdr">
          <h3>Battery</h3>
        </div>

        <div className="row rowStretch">
          <div className="col col50">
            <label className="chk-option">
              <input type="checkbox" className="chk" checked />
              <span className="chkmrk chkmrk-disabled"></span>
              <span className="lblTxt">1. Device has triggered EOL</span>
            </label>
            <label className="chk-option">
              <input type="checkbox" className="chk" />
              <span className="chkmrk"></span>
              <span className="lblTxt">2. Device has triggered ERI</span>
            </label>
          </div>
        </div>

        <div className="grpHdr">
          <h3>Lead</h3>
        </div>

        <div className="row rowStretch">
          <div className="col col50">
            <label className="lead">
              <span>
                3. Impedance &lt; _____ &ohm; &gt; or ____ &ohm; and the current value is inconsistent with
                previously trend values
              </span>
              <div className="row noMargin">
                <div className="col">
                  <input type="text" value="" className="impedance-input" />
                </div>
                <div className="col">
                  <input type="text" value="" className="impedance-input" />
                </div>
              </div>
            </label>
          </div>
        </div>

        <div className="row rowStretch">
          <div className="col col50">
            <label className="chk-option">
              <input type="checkbox" className="chk" />
              <span className="chkmrk"></span>
              <span className="lblTxt">4. Abrupt change in P or R wave identified.</span>
            </label>
            <label className="chk-option">
              <input type="checkbox" className="chk" />
              <span className="chkmrk"></span>
              <span className="lblTxt">5. Abrupt change in capture threshold identified.</span>
            </label>
          </div>
        </div>
      </div>
      {!information.openForm ? (
        <div
          style={{
            position: "absolute",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            backgroundColor: "rgba(255,255,255,0.25)",
          }}
        />
      ) : null}
    </div>
  );
};

export default FacilityDoc;
